import React from 'react';
import { ContentWrapper } from 'components/storefront/editor/easyblocks-page/components';
import parseHtmlToReact, {
  processLayoutGroupSections,
  processStylesheet,
  processStyle,
  processScripts,
  processBody,
  processLayoutContent,
  processHtml,
  processForm,
  processButton,
  processLink,
  processCustomNode,
  processDefaultNode,
} from 'components/storefront/editor/easyblocks-page/parser/html-to-react';

/** @typedef {import('@swell/apps-sdk').SwellTheme} SwellTheme */
/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {SwellTheme} theme
 * @param {string} pageContentString
 * @param {AssetLoader} assetLoader
 */
function getInstructions(theme, pageContentString, assetLoader) {
  const bodyItems = [];

  return [
    processLayoutGroupSections(assetLoader),
    processStylesheet(assetLoader),
    processStyle(assetLoader),
    processScripts(assetLoader),
    processBody(bodyItems),
    processLayoutContent(pageContentString),
    processHtml(bodyItems),
    processForm(theme),
    processButton(theme),
    processLink(theme),
    processCustomNode,
    processDefaultNode,
  ];
}

/**
 * @param {SwellTheme} theme
 * @param {AssetLoader} assetLoader
 * @param {string} template
 * @param {string} pageContentString
 */
function parse(theme, assetLoader, template, pageContentString) {
  const RootElements = parseHtmlToReact(
    template,
    getInstructions(theme, pageContentString, assetLoader),
  );

  const Content = RootElements.find(
    (element) => element.type === ContentWrapper,
  ) || {
    type: () => (
      // TODO: nicer UI for rendering this error
      <div>Theme layout is missing a valid &lt;html&gt; tag</div>
    ),
    props: {},
  };

  return { Content };
}

export default parse;
